import { render, staticRenderFns } from "./breed_segment_sel.vue?vue&type=template&id=45aee688&scoped=true"
import script from "./breed_segment_sel.vue?vue&type=script&lang=js"
export * from "./breed_segment_sel.vue?vue&type=script&lang=js"
import style0 from "./breed_segment_sel.vue?vue&type=style&index=0&id=45aee688&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aee688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45aee688')) {
      api.createRecord('45aee688', component.options)
    } else {
      api.reload('45aee688', component.options)
    }
    module.hot.accept("./breed_segment_sel.vue?vue&type=template&id=45aee688&scoped=true", function () {
      api.rerender('45aee688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_segment_sel.vue"
export default component.exports